module.exports = __webpack_public_path__ + "img/tss-11.a1bd249d.jpg";